module.exports = __webpack_public_path__ + "img/SKMJ_train2.3a099dd7.jpg";